import {useState} from 'react';
import {a11yProps} from "../../helpers/a11y"
import { Typography, AppBar, Tabs, Tab } from "@material-ui/core"
import InvoiageLogo from '../InvoiageLogo';
import { useUser } from '../../../contexts/UserContext';
export default function ValidationAppBar({validationTabIndex, setValidationTabIndex}) {

  const boxShadow = "0px 3px 4px -1px rgba(0,0,0,0.2)"
  const {user} = useUser()

  return (
    <AppBar position="static" color="default" style={{boxShadow}}>
      <Typography variant="h2">Invoiage <InvoiageLogo /> Review</Typography>
      {user.admin && <Tabs   
          centered 
          indicatorColor="primary" 
          value={validationTabIndex} 
          onChange={(e, val) => setValidationTabIndex(val)}>
          <Tab label="Daily" {...a11yProps(0)} />
          <Tab label="Browse All" {...a11yProps(1)} />
          <Tab label="Olive 🤖" {...a11yProps(2)} />
      </Tabs>}
    </AppBar>
  )
}